// The backend tools that can pause a run awaiting human input (deferred or
// approval-required in pydantic-ai terms). Mirrors the analysis-agent's own
// pausing set rather than the cards registered in AnalysisAgentTools, because
// what matters here is which tool results the client authors: a pausing tool's
// result comes from the user, every other result comes from the server.
const HITL_TOOL_NAMES: ReadonlySet<string> = new Set([
  "ask_user_question",
  "ask_for_approval",
  "pipeline_submit_run",
  "pipeline_cancel_run",
]);

export const isHitlTool = (name: string): boolean => HITL_TOOL_NAMES.has(name);
